(function (angular) {
    'use strict';

    angular.module('chat2')
        /**
         * Note: if teamAvatar is undefined, we DONT want to show the `View history` action (we are in start chat state)
         */
        .controller('participantProfileCtrl',
            ['$rootScope', '$scope', '$uibModal', 'participantProfile', '$state', '$stateParams', 'profilesService', 'teamAvatar', 'growlService', 'comapiChatService', 'conversationInfo', 'profileHelper', 'teamConfig',
                function ($rootScope, $scope, $uibModal, participantProfile, $state, $stateParams, profilesService, teamAvatar, growlService, comapiChatService, conversationInfo, profileHelper, teamConfig) {

                    // handle the case of a deleted profile by swapping for an empty profile
                    if(participantProfile === null){
                        participantProfile = {
                            profile: {
                                generalProperties:{
                                    properties: {
                                        "firstName": {
                                            "label": "First Name",
                                            "type": "string",
                                          },
                                          "lastName": {
                                            "label": "Last Name",
                                            "type": "string",
                                          },
                                          "_createdOn": {
                                            "label": "Created",
                                            "type": "date",
                                          },                                  
                                          "_lastActivityOn": {
                                            "label": "Last Seen",
                                            "type": "date",
                                          },
                                    }
                                }
                            },
                            isLinked: false,

                        }
                    }

                    $scope.participantProfile = participantProfile.profile;

                    $scope.participantProfileCopy = angular.copy(participantProfile.profile);

                    $scope.hasRelationships = participantProfile.isLinked;

                    $scope.teamAvatar = teamAvatar;

                    $scope.generalProperties = [];

                    if(participantProfile.profile.generalProperties.properties.id){
                        $scope.generalProperties.push(participantProfile.profile.generalProperties.properties.id);
                    }

                    if(participantProfile.profile.generalProperties.properties.email){
                        $scope.generalProperties.push(participantProfile.profile.generalProperties.properties.email);
                    }
                    
                    if(participantProfile.profile.generalProperties.properties.phoneNumber){
                        $scope.generalProperties.push(participantProfile.profile.generalProperties.properties.phoneNumber);    
                    }
                    
                    $scope.edit = false;
                    var conversationChannel = conversationInfo.conversation ? conversationInfo.conversation.channelId : "";

                    var hsmReEngagementConfigured = teamConfig && teamConfig.channels && teamConfig.channels.whatsApp && teamConfig.channels.whatsApp.reengagementHsm;

                    function sendHsm(){
                        if(hsmReEngagementConfigured){
                            let message = {
                                parts: [{
                                    type: "whatsapp/template",
                                    data: {
                                        languageCode: teamConfig.channels.whatsApp.reengagementHsm.languageCode,
                                        templateName: teamConfig.channels.whatsApp.reengagementHsm.templateName,
                                        namespace: teamConfig.channels.whatsApp.reengagementHsm.namespace
                                    }
                                }]
                            }
                            return comapiChatService.chatClient.messaging.sendMessage($stateParams.id, message)
                                .then((result) => {
                                    return result;
                                })
                                .catch((error) => {
                                    growlService.danger("Failed to send HSM message");
                                    throw error;
                                });
                        }
                    }

                    //list of custom interactions
                    
                    $scope.interactions = [{
                        id: "reengagementHsm",
                        templateUrl: "./components/toolkit/profiles/templates/interactions/reengagementHsm.html",
                        shouldDisplay: function(){
                            if(conversationChannel === "whatsApp" && participantProfile.profile && participantProfile.profile.whatsApp){
                                return profileHelper.outOfCounter(participantProfile.profile.whatsApp.properties.timeLeftToChat) && hsmReEngagementConfigured;
                            }
                            return false;
                        },
                        controller: {
                            sendHsm: sendHsm
                        }
                    }];

                    //changing object to array and sorting so we have picked channel on top of properties
                    $scope.getParticipantProfileSections = function(){
                        var result = Object.keys($scope.participantProfile).map(function(key) {
                            var obj = $scope.participantProfile[key];
                            obj.id = key;
                            return obj;
                          }).sort(function(v1, v2){
                              if(v1.channel === conversationChannel){
                                return -1;  
                              } else if(v2.channel === conversationChannel){
                                return 1;  
                              }
                              return 0;
                          });
                        return result;
                    }

                    //handling message being received
                    function conversationMessageEventHandler(event){
                        if(event.conversationId === $stateParams.id && event.name === "conversationMessage.sent" && event.payload.context.direction === "inbound"){
                            $scope.participantProfile.whatsApp.properties.timeLeftToChat.value = event.payload.context.sentOn;
                            $scope.participantProfile.facebook.properties.timeLeftToChat.value = event.payload.context.sentOn;
                        }
                    }
                    
                    comapiChatService.addEventListener("conversationMessageEvent", conversationMessageEventHandler);

                    $scope.$on("$destroy", function() {
                        comapiChatService.removeEventListener("conversationMessageEvent", conversationMessageEventHandler);
                    });

                    $scope.toggleEdit = function () {
                        $scope.edit = !$scope.edit;
                    }

                    $scope.linkProfile = function () {
                        var modalInstance =
                            $uibModal.open({
                                templateUrl: "components/toolkit/profiles/templates/profileSearchModal.html",
                                resolve: {
                                    buttonInfo: [function () {
                                        return {
                                            icon: "link",
                                            text: "Link",
                                            class: "btn-primary"
                                        };
                                    }],
                                    profileSchema: ['$q', 'profilesService', '$stateParams', 'profileHelper',
                                        function ($q, profilesService, $stateParams, profileHelper) {
                                            if (profileHelper.getSchema().length) {
                                                return profileHelper.getSchema();
                                            }
                                            else {
                                                return profilesService.getProfileSchema($stateParams.pickedApiSpaceId)
                                                    .then(function (result) {
                                                        return profileHelper.setSchema(result);
                                                    }).catch(function (result) {
                                                        var deferred = $q.defer();
                                                        if (result.status < 500) { deferred.resolve(result); } else { deferred.reject(result); }
                                                        return deferred.promise;
                                                    });
                                            }
                                        }],
                                },
                                controller: 'profileSearchModal',
                                size: 'lg',
                            });

                        modalInstance.result
                            .then(function (profile) {
                                // do logic
                                return profilesService.linkProfile($stateParams.pickedApiSpaceId, $scope.participantProfile.generalProperties.properties.id.value, profile.id)
                                    .then(function (result) {
                                        
                                        comapiChatService.updateConversationsFromPrimaryProfile($scope.participantProfile.generalProperties.properties.id.value, profile.id)
                                            .then(function () {
                                                $state.reload();
                                                growlService.success('Profile Linked');
                                            });
                                    })
                                    .catch(function (error) {
                                        if (error !== 'backdrop click') {
                                            console.error(error);
                                            growlService.danger("Failed to link profiles, due to: " + error.statusText);
                                        }
                                    });
                            }, function () {
                                // action on popup dismissal.
                            });

                    }

                    $scope.viewHistory = function () {

                        if (teamAvatar) {
                            $uibModal.open({
                                templateUrl: "components/toolkit/chat/templates/chatHistory.html",
                                resolve: {
                                    profileData: $scope.participantProfile,
                                    teamAvatar: function () {
                                        return teamAvatar;
                                    }
                                },
                                controller: 'MessageHistoryModalCtrl'
                            });
                        }
                    }

                    $scope.saveProfile = function () {

                        // build an object that we can use to call patch with ...
                        $rootScope.$broadcast('profile:save');

                        var profile = profileHelper.getProfileData($scope.participantProfile, $scope.participantProfileCopy);
                        var profileToPatch = profile.dataToPatch;
                        var propertiesToDelete = profile.emptyProperties;

                        var id = participantProfile.profile.generalProperties.properties.id.value;
                        profilesService.patchProfile($stateParams.pickedApiSpaceId, id, profileToPatch, propertiesToDelete).then(function (result) {
                            $scope.edit = false;
                            $scope.participantProfileCopy = angular.copy($scope.participantProfile);
                            growlService.success("Profile successfully updated");
                            $rootScope.$broadcast("profile:patched", result);
                        }).catch(function (error) {
                            growlService.danger("Profile wasn't updated due to: " + error.statusText);
                        });


                    }


                }]);

})(window.angular);